import { isDateInPast } from '@eventr/common'
import {
    ColoursObj,
    ImageRenderer,
    Typography,
    getContrastYIQ,
} from '@eventr/common-storybook'
import { Box, Stack } from '@mui/material'
import { useShallow } from 'zustand/react/shallow'
import i18n from '../../../i18n/i18next'
import { useBoundStore } from '../../../state/bound.store'
import { useRouteGuardContext } from '../../../state/routeGuardProvider'
import { useThemeContext } from '../../../state/themeState/themeContext'
import { EventEndedContent } from '../AddEmptyItinerarySplash'

export const EmptyItineraryInstructionsTeam = () => {
    const { selectedItinerary } = useBoundStore(
        useShallow((s) => {
            return { selectedItinerary: s.selectedItinerary }
        })
    )
    const themeImages = useThemeContext((s) => s.themeImages)
    const { isAllowed } = useRouteGuardContext()
    return (
        <Box padding="16px">
            <Stack
                width="100%"
                justifyContent="center"
                alignItems="center"
                flexDirection="column"
                gap="24px"
            >
                <Typography
                    id={
                        isDateInPast(selectedItinerary?.v2?.[0]?.data?.end_date ?? '')
                            ? 'teamPageItineraryEndedTitle'
                            : 'teamPageWelcomeTitle'
                    }
                    variant="mobileH3"
                    color={getContrastYIQ(ColoursObj.backgrounds.primary)}
                >
                    {isDateInPast(selectedItinerary?.v2?.[0]?.data?.end_date ?? '')
                        ? i18n.t('home.itinerary-ended')
                        : i18n.t('team.welcome-team-page')}
                </Typography>

                {isDateInPast(selectedItinerary?.v2?.[0]?.data?.end_date ?? '') ? (
                    <ImageRenderer
                        variant="eventEnded"
                        src={themeImages?.eventEnded}
                    />
                ) : (
                    <ImageRenderer
                        variant="teamEmpty"
                        src={themeImages?.teamEmpty}
                    />
                )}
                {isDateInPast(selectedItinerary?.v2?.[0]?.data?.end_date ?? '') ? (
                    <EventEndedContent />
                ) : isAllowed(['allowedEdit']) ? (
                    <Stack alignItems={'center'} width="100%">
                        <Typography
                            id="teamPageBetterSubText"
                            color={getContrastYIQ(
                                ColoursObj.backgrounds.primary
                            )}
                            variant="bodyBold"
                        >
                            {i18n.t('team.better-with-team')}
                        </Typography>
                        <Typography
                            id="teamPageAddTeamMembersSubText"
                            color={getContrastYIQ(
                                ColoursObj.backgrounds.primary
                            )}
                        >
                            {i18n.t('team.add-team-members')}
                        </Typography>
                    </Stack>
                ) : (
                    <Stack gap="8px">
                        <Typography
                            align="center"
                            color={getContrastYIQ(
                                ColoursObj.backgrounds.primary
                            )}
                        >
                            {i18n.t('home.no-edit-permission')}
                        </Typography>
                    </Stack>
                )}
            </Stack>
        </Box>
    )
}
